<template>
    <v-card
        class="products-featured-item carousel-h-scroll-parent position-relative"
        :to="url"
        :ripple="false"
    >
        <ProductFlags
            v-if="sku.flags"
            class="card-top-product-flags"
            v-model="sku.flags"
            size="small"
            density="compact"
            label
        ></ProductFlags>

        <v-card-text
            class="d-flex flex-column h-100 no-user-select"
        >
            <ProductsImage
                :image-object="skuImgObj"
                class="mx-auto"
            ></ProductsImage>

            <div
                class="d-flex flex-column justify-space-between flex-grow-1 gap-2 mt-4"
            >
                <div>
                    <h5
                        class="font-weight-bold font-size-7 py-0 my-0"
                    >
                        {{ sku.productName }}
                    </h5>
                </div>
                <div>
                    <template v-if="sku?.userDiscount && sku.userDiscount > 0">
                        <div>
                            <span class="font-size-7 font-weight-bold v-align-middle mr-3">
                                {{ sku.userPriceFmt }}
                            </span>
                            <span class="font-weight-bold v-align-middle text-disabled text-strike-diag">
                                {{ sku.priceFmt }}
                            </span>
                        </div>
                        <v-chip
                            class="font-weight-bold text-uppercase letter-spacing-6 mt-2"
                            color="success"
                            size="x-small"
                            label
                        >
                            {{ sku.userDiscountFmt }} off
                        </v-chip>
                    </template>
                    <template v-else>
                        <span class="font-weight-bold font-size-7 v-align-middle">
                            {{ sku.priceFmt }}
                        </span>
                    </template>
                </div>
            </div>
        </v-card-text>
    </v-card>
</template>

<script lang="ts" setup>
    import type { Sku, FullImage } from '~/types';
    import ProductsImage from '~/components/products/ProductsImage/ProductsImage.vue';
    import ProductFlags from '~/components/products/ProductFlags/ProductFlags.vue';
    import { pathJoin } from 'x1-base/utils';

    const props = defineProps<{
        sku: Sku;
        useDefaultImage?: boolean;
    }>();

    const url = ref<Undefinable<string>>(
        props.sku?.path ?
            `${pathJoin('/', props.sku.path)}` : undefined
    );

    const skuImgObj = ref<Nullable<FullImage>>(
        (props.useDefaultImage ? props.sku.defaultImage : props.sku.images?.[0]) ?? null
    );
</script>

<style lang="scss">
@use '~GlobalVars' as vars;

.products-featured-item {
    width: vars.$products-featured-item-width;

    img {
        width: vars.$products-featured-img-size;
        height: vars.$products-featured-img-size;
        aspect-ratio: 1;
        object-fit: contain;
    }
}
</style>
